<div class="maxContainerWidth">
    <div class="contentWrap flex justify-between items-center"  [ngClass]="{'reverse': data.reverse == true}">
        <div class="imgWrap">
            <img src="assets/images/case-study-page/{{data.imgSrc}}" alt="">
        </div>
        <div class="textWrap">
            <h2 class="text-white">
                {{data.title}}
            </h2>
            <p [innerHTML]="data.description">
                

            </p>
        </div>
    </div>
</div>